import React from 'react';

import { Button, Modal } from 'semantic-ui-react';

const ConfirmMessage = ({
    message = '',
    confirmBtnText = 'Submit',
    cancelBtnText = 'Cancel',
    open = false,
    handleClose,
    handleConfirm,
    isDisabled = false,
    hideActions = false,
    size = 'small',
    closeIcon = false, 
    secondaryButtonFirst = false,
    className = '',
    hideConfirmBtn = false
}) => {
    return (
        <Modal className={className} size={size} closeIcon={closeIcon} open={open} onClose={cancelBtnText === 'Proceed' ? handleConfirm : handleClose}>
            <Modal.Content content={message} />

            <Modal.Actions>
                {!hideActions && !secondaryButtonFirst && (
                    <Button.Group>
                        <Button
                            onClick={handleClose}
                            content={cancelBtnText}
                        />
                        {!hideConfirmBtn &&
                        <Button onClick={handleConfirm} disabled={isDisabled} content={confirmBtnText} 
                            secondary
                            className="bold" 
                            style={{ borderLeft: '1px solid #000', marginRight: 10 }}/>
                        }
                    </Button.Group>
                )}

                {!hideActions && secondaryButtonFirst && (
                    <Button.Group>
                        <Button onClick={handleConfirm} disabled={isDisabled} content={confirmBtnText} 
                            secondary
                            className="bold" 
                            style={{ borderLeft: '1px solid #000', marginRight: 10 }}/>
                        <Button
                            onClick={handleClose}
                            content={cancelBtnText}
                        />
                    </Button.Group>
                )}
            </Modal.Actions>
        </Modal>
    );
};

export default ConfirmMessage;
